export const unit_level_colors = ["magenta", "green", "cyan", "gold"];
